// eslint-disable-next-line import/prefer-default-export
const PERSONA_DATA_NO_GOALS_COMPLETE = {
  traits: {
    'Account Created At': '2011-04-09T01:00:18.000Z',
    'Account Name': 'PagerDuty Internal Alerts',
    'Account Plan': 'enterprise',
    'Account Size': 826,
    'Account State': 'active',
    'Created At': '2019-07-04T12:43:47.000Z',
    Email: 'jemmrich@pagerduty.com',
    'Job Title': 'Software Engineer',
    Role: 'user',
    'Sub Domain': 'pdt-circular',
    Title: 'Software Engineer',
    'User Type': 'user',
    account_id: null,
    account_name: null,
    account_revenue_segment: null,
    account_state: null,
    anonymousId: 'mobile',
    company: 'pdt-jemmrich-testing-trial-form',
    createdAt: '2019-07-04T12:43:47.000Z',
    demand_base_annual_sales: '100000000',
    demand_base_company_name: 'PagerDuty',
    demand_base_country_code: 'CA',
    demand_base_country_name: 'Canada',
    demand_base_employee_count: '500',
    demand_base_employee_range: 'Mid-Market',
    demand_base_phone_number: '844-700-3889',
    demand_base_primary_industry: 'Software \u0026 Technology',
    demand_base_revenue_range: '$100M - $250M',
    demand_base_state: 'ON',
    email: 'jemmrich@pagerduty.com',
    employees: 826,
    favorite_pricing_plan_clicked: 'Platform Team',
    first_name: 'James',
    ga_clientid: '1717788393.1574289241',
    groupId: 'PFIGZHD',
    last_name: 'Emmrich',
    marketing_site_users_active: true,
    name: 'James Emmrich',
    north_america_aud_using_db_event: false,
    nurture_bar_add_users_to_your_account: false,
    nurture_bar_download_the_mobile_app: false,
    nurture_bar_download_the_mobile_app_v_2: false,
    phone: '+15555555555',
    subdomain: 'pdt-circular',
    timezone: 'UTC-04:00',
    timezone_name: 'America/Toronto',
    userId: 'PI8FRYL'
  },
  cursor: {
    url: '',
    has_more: false,
    next: '',
    limit: 200
  }
};

const PERSONA_DATA_ADDED_USERS = {
  ...PERSONA_DATA_NO_GOALS_COMPLETE,
  traits: {
    ...PERSONA_DATA_NO_GOALS_COMPLETE.traits,
    nurture_bar_add_users_to_your_account: true,
  }
};

const PERSONA_DATA_DOWNLOADED_APP = {
  ...PERSONA_DATA_NO_GOALS_COMPLETE,
  traits: {
    ...PERSONA_DATA_NO_GOALS_COMPLETE.traits,
    nurture_bar_download_the_mobile_app_v_2: true,
  }
};

const PERSONA_DATA_VIEWED_ON_CALL_GOAL = {
  ...PERSONA_DATA_NO_GOALS_COMPLETE,
  traits: {
    ...PERSONA_DATA_NO_GOALS_COMPLETE.traits,
    nurture_bar_seen_managing_on_call_shifts: true,
  }
};

const PERSONA_DATA_VIEWED_ACK_AND_OWN_GOAL = {
  ...PERSONA_DATA_NO_GOALS_COMPLETE,
  traits: {
    ...PERSONA_DATA_NO_GOALS_COMPLETE.traits,
    nurture_bar_seen_acking_and_owning: true,
  }
};

export default {
  PERSONA_DATA_NO_GOALS_COMPLETE,
  PERSONA_DATA_ADDED_USERS,
  PERSONA_DATA_DOWNLOADED_APP,
  PERSONA_DATA_VIEWED_ON_CALL_GOAL,
  PERSONA_DATA_VIEWED_ACK_AND_OWN_GOAL,
};
